"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Button_1 = require("@Components/Buttons/Button");
const ConfirmationStep = (props) => {
    const { closeSidebar } = props;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("h2", null, "Thank you for submitting your request"),
        react_1.default.createElement("p", null, "You'll receive a confirmation email of this submission."),
        react_1.default.createElement("p", null, "The MLC will review the submission and follow-up via email to let you know if your suggested change is accepted."),
        react_1.default.createElement(Button_1.Button, { mainColor: true, type: 'primary', onClick: closeSidebar }, "Done")));
};
exports.default = ConfirmationStep;
